import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CaseManagementComponent } from './case-management-dialog/case-management/case-management.component'
import { LetModule } from '@ngrx/component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { CaseManagementDialogComponent } from './case-management-dialog/case-management-dialog.component'
import { NoCaseComponent } from './no-case/no-case.component'
import { UploadComponent } from './case-management-dialog/upload/upload.component'
import { SharedModule } from '../shared/shared.module'
import { DeleteNodeConfirmationDialogComponent } from './case-management-dialog/case-management/delete-node-confirmation-dialog/delete-node-confirmation-dialog.component'
import { AddNewFolderDialogComponent } from './case-management-dialog/case-management/add-new-folder-dialog/add-new-folder-dialog.component'
import { FormsModule } from '@angular/forms'
import { UploadFileComponent } from './case-management-dialog/upload/upload-file/upload-file.component'
import { UploadProgressBarComponent } from './case-management-dialog/upload/upload-file/upload-progress-bar/upload-progress-bar.component'

@NgModule({
    declarations: [
        CaseManagementComponent,
        CaseManagementDialogComponent,
        NoCaseComponent,
        UploadComponent,
        DeleteNodeConfirmationDialogComponent,
        AddNewFolderDialogComponent,
        UploadFileComponent,
        UploadProgressBarComponent,
    ],
    imports: [CommonModule, LetModule, UiLibraryModule, SharedModule, FormsModule],
    exports: [CaseManagementDialogComponent],
})
export class CaseManagementModule {}
